import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl: string = environment.baseUrl;

	constructor(private http: HttpClient) { }

	login(username: string, password: string, role_id: string): Observable<any> {
		const url = `${this.baseUrl}/auth/login`;
		const body = { username, password, role_id };
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

		return this.http.post(url, body, { headers }).pipe(
			catchError(this.handleError)
		);
	}

	// forgotPassword(username: string): Observable<any> {
	// 	return this.http.post(`${this.baseUrl}/auth/forgotPassword`, { username });
	//   }

	//   verifyResetPasswordToken(token: string): Observable<any> {
	// 	return this.http.post(`${this.baseUrl}/auth/verifyResetToken`, { token });
	//   }
	
	//   resetPassword(token: string, newPassword: string): Observable<any> {
	// 	return this.http.post(`${this.baseUrl}/auth/resetPassword`, { token, newPassword });
	//   }

	verifyResetOtp(username: string, otp: string): Observable<any> {
		return this.http.post(`${this.baseUrl}/auth/verifyResetOtp`, { username, otp });
	  }

	forgotPassword(username: string): Observable<any> {
		return this.http.post(`${this.baseUrl}/auth/forgotPassword`, { username });
	  }
	
	//   verifyResetPasswordToken(token: string): Observable<any> {
	// 	return this.http.post(`${this.baseUrl}/auth/verifyResetToken`, { token });
	//   }
	  verifyResetPasswordToken(mobile: string,otp: string): Observable<any> {
		return this.http.post(`${this.baseUrl}/auth/verifyResetOtp`, { mobile, otp });
	  }
	  
  resetPassword(payload: { username: string, otp: string; password: string; cpassword: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/resetPassword`, payload);
  }

	private handleError(error: any): Observable<never> {
		// console.error('An error occurred', error);
		return throwError(error.message || error);
	}
}
